import React, { Component } from 'react';
import '../css/hero.css'
import SocialButton from './SocialButton';
import { LanguageContext } from '../contexts/LanguageContext';

function darkenColor(hex, amount = 70) {
    let col = hex.replace("#", "");
    if (col.length === 3) {
        col = col.split("").map(c => c + c).join("");
    }

    const num = parseInt(col, 16);
    let r = (num >> 16) - amount;
    let g = ((num >> 8) & 0x00FF) - amount;
    let b = (num & 0x0000FF) - amount;

    r = Math.max(0, r);
    g = Math.max(0, g);
    b = Math.max(0, b);

    return `rgb(${r}, ${g}, ${b})`;
}

class Hero extends Component {
    static contextType = LanguageContext

    state = {
        discordData: null,
        loading: true,
        error: null
    };

    fetchLanyardAPI = (userID) => {
        fetch(`https://api.lanyard.rest/v1/users/${userID}`)
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then(data => {
                this.setState({
                    discordData: data.data,
                    loading: false
                });
            })
            .catch(error => {
                console.error("Error fetching Discord data:", error);
                this.setState({
                    error: "Failed to load Discord profile",
                    loading: false
                });
            });
    };

    handleScrollDown = () => {
        const destination = document.getElementById("projects")
        destination.scrollIntoView({ behavior: "smooth" });
    }

    componentDidMount() {
        fetch('/data/user.json')
            .then(res => res.json())
            .then(data => {
                this.fetchLanyardAPI(data.id);
            })
            .catch(error => {
                console.error("Fehler beim Laden der user.json:", error);
                this.setState({
                    error: "Failed to load user ID",
                    loading: false
                });
            });
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    render() {
        const { translations } = this.context;
        const { discordData, loading, error } = this.state;

        const defaultData = {
            discord_user: {
                username: "Username",
                display_name: "Display Name",
                avatar: null,
                id: null
            },
            discord_status: "offline"
        };

        const data = discordData || defaultData;
        const user = data.discord_user;

        let avatarUrl;
        if (user.avatar && user.id) {
            avatarUrl = `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png?size=256`;
        } else {
            const discriminator = user.discriminator || '0';
            const defaultAvatarIndex = discriminator === '0' ? 0 : parseInt(discriminator) % 5;
            avatarUrl = `https://cdn.discordapp.com/embed/avatars/${defaultAvatarIndex}.png`;
        }

        const statusColors = {
            online: "#3BA55D",
            idle: "#FAA61A",
            dnd: "#ED4245",
            offline: "#747F8D"
        };

        // Status-Texte für den Tooltip
        const statusTexts = {
            online: translations?.hero_status_tooltip_online,
            idle: translations?.hero_status_tooltip_idle,
            dnd: translations?.hero_status_tooltip_dnd,
            offline: translations?.hero_status_tooltip_offline
        };

        return (
            <section id="home">
                <div className='hero-container'>
                    <div className="avatar-container">
                        <img
                            id='userAvatar'
                            src={avatarUrl}
                            alt='Discord Profile'
                            className="discord-avatar"
                            onError={(e) => {
                                e.target.src = "https://cdn.discordapp.com/embed/avatars/0.png";
                            }}
                        />
                        <div className="status-container">
                            <div
                                className="status-indicator"
                                style={{
                                    backgroundColor: statusColors[data.discord_status],
                                    border: `4px solid ${darkenColor(statusColors[data.discord_status])}`,
                                }}
                            />

                            <span className="status-tooltip">{statusTexts[data.discord_status]}</span>
                        </div>
                    </div>

                    <h1 id='userName'>{user.display_name || user.username}</h1>
                    <p id='userTag'>{user.username}</p>

                    {loading && <p>Loading Discord data...</p>}
                    {error && <p className="error">{error}</p>}

                    <h5 id='userRoles'>{translations?.hero_user_roles}</h5>
                    <div id='userQuote'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-crown-icon lucide-crown"><path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z" /><path d="M5 21h14" /></svg>  The only way to do great work is to love what you do.
                    </div>

                    <div className="social-buttons-container">
                        <SocialButton iconName="github-logo" link='https://github.com/NetroTim' />
                        <SocialButton iconName="discord-logo" link='https://discord.com/users/695721640192901262' />
                        <SocialButton iconName="instagram-logo" link='https://instagram.com/papaplatte' />
                    </div>
                    <div className='down-arrow-container'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down" onClick={this.handleScrollDown}><path d="m6 9 6 6 6-6" /></svg>
                    </div>

                </div>
            </section>
        );
    }
}

export default Hero;